import axios from "axios";

export default {
  getAll(accessToken,page, br_postupka, faza, broj_predmeta, start_date, end_date, isArchived, isDestroyed, year_filter, id_person) {
    try {
      console.log(accessToken);
      return axios.get("https://app-psod.cratis.cloud/predmeti", {
        params: {
          token: accessToken,
          page,
          br_postupka, 
          faza,
          broj_predmeta,
          start_date,
          end_date,
          isArchived,
          isDestroyed,
          year_filter,
          id_person
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  searchPredmeti(srch_txt) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/search", {
        params: {
          srch_txt
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at search.");
    }
  },
  getAllOdvjetniciShort() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/odvjetnici", {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at search.");
    }
  },
  getAllFilteri() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/filteri", {
        params: {},
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllPhases() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/faze", {
        params: {},
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getCaseTeam(predmetId) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/"+predmetId+"/team", {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  
  getUserCasePermissions(predmetId, user_id) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/"+predmetId+"/permissions", {
        params: {
          user_id : user_id
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getCaseTeamShort(predmetId) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/"+predmetId+"/team_short", {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllSluzbenaUloga() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/sluzbena-uloga", {
        params: {},
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllOznakeStatus() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/oznake-status", {
        params: {},
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addOznakeStatus(sifra_val) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/oznake-status", {
        params: {
          sifra_val
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addSluzbenaUloga(sifra_val) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/sluzbena-uloga", {
        params: {
          sifra_val
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllPostupci() {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/postupci", {
        params: {},
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addNewPostupak(sifra_val) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/postupci", {
        params: {
          sifra_val
        },
        credentials: true,
      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  addNewFaza(sifra_val) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/faze", {
        params: {
          sifra_val
        },
        credentials: true,
      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  updatePostupak(sifra_val, id) {
    try {
      return axios.put("https://app-psod.cratis.cloud/predmeti/postupci/"+id, {
        params: {
          sifra_val
        },
        credentials: true,
      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  deletePostupak(id) {
    try {
      return axios.delete("https://app-psod.cratis.cloud/predmeti/postupci/"+id, {
        credentials: true,
      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateOrderSifre(sifra_val, id) {
    try {
      return axios.put("https://app-psod.cratis.cloud/predmeti/sifre-order/"+id, {
        params: {
          sifra_val
        },
        credentials: true,
      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateFaze(sifra_val, id) {
    try {
      return axios.put("https://app-psod.cratis.cloud/predmeti/faze/"+id, {
        params: {
          sifra_val
        },
        credentials: true,
      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteFaze(id) {
    try {
      return axios.delete("https://app-psod.cratis.cloud/predmeti/faze/"+id, {
        credentials: true,
      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateOznakeStatus(sifra_val, id) {
    try {
      return axios.put("https://app-psod.cratis.cloud/predmeti/oznake-status/"+id, {
        params: {
          sifra_val
        },
        credentials: true,
      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteOznakeStatus(id) {
    try {
      return axios.delete("https://app-psod.cratis.cloud/predmeti/oznake-status/"+id, {
        credentials: true,
      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateSluzbenaUloga(sifra_val, id) {
    try {
      return axios.put("https://app-psod.cratis.cloud/predmeti/sluzbena-uloga/"+id, {
        params: {
          sifra_val
        },
        credentials: true,
      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteSluzbenaUloga(id) {
    try {
      return axios.delete("https://app-psod.cratis.cloud/predmeti/sluzbena-uloga/"+id, {
        credentials: true,
      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllBrojevi(accessToken) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/broj_predmeta", {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },

  getSingle(predmetId) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/"+predmetId, {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addPredmet(unos_predmeta, access_token, logged_uid) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/init-case", {
        params: {
          unos_predmeta,
          access_token,
          logged_uid
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updatePredmet(unos_predmeta, access_token,predmet_id, logged_uid) {
    try {
      return axios.put("https://app-psod.cratis.cloud/predmeti/"+predmet_id, {
        params: {
          unos_predmeta,
          access_token,
          logged_uid
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateOrdering(predmet_id, participant_order) {
    try {
      return axios.put("https://app-psod.cratis.cloud/predmeti/"+predmet_id+"/participant-order", {
        params: {
          participant_order
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  
  addPredmetGraph(unos_predmeta, access_token, graph_url) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/initialize/graph", {
        params: {
          unos_predmeta,
          access_token,
          graph_url
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  arhivirajPredmet(predmet_id, datum_arhiviranja) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/"+predmet_id+"/arhiviraj", {
        params:{
          datum_arhiviranja
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  aktivirajPredmet(predmet_id) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/"+predmet_id+"/aktiviraj", {
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  unistiPredmet(predmet_id, datum_unistavanja) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/"+predmet_id+"/unisti", {
        params:{
          datum_unistavanja
        }, 
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  // NAPOMENE START
  addPredmetNapomena(napomena,group_url) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/"+group_url+"/napomene", {
        params: {
          napomena
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPredmetNapomene(group_url) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/"+group_url+"/napomene");
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getCaseTasks(group_url) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/"+group_url+"/tasks");
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  // NAPOMENE END
};
